// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("logotype.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
:root, * {
  --theme-primary-text-color: #333;
  --theme-secondary-text-color: #666;
  --theme-disabled-text-color: #999;
  --theme-main-background-color: #f5f5f5;
  --theme-primary-background-color: #ffffff;
  --theme-accent-color: #3B9EA3;
  --theme-secondary-accent-color: #d1e7e8;
  --theme-accent-text-color: #ffffff;
  --theme-overlay-color: #00000080;

  --drawer-width: 20rem;
}

.material-symbols-outlined {
  font-variation-settings:
  'FILL' 1;
}

:root, body, #root, #app {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

body {
  margin: 0;
  padding: 0;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  background-color: var(--theme-main-background-color);
  color: var(--theme-primary-text-color);
}

#app {
  display: grid;
  grid-template-rows: [app-start top-bar-start] 3rem [top-bar-end main-start] 1fr [main-end app-end];
  transition: ease-in-out 0.3s grid-template-columns;
}

#app.app-drawer-closed {
  grid-template-columns: [app-start main-start drawer-start] 0 [drawer-end] 1fr [main-end app-end];
}

#app.app-drawer-open {
  grid-template-columns: [app-start main-start drawer-start] var(--drawer-width) [drawer-end] 1fr [main-end app-end];
}

#app-top-bar {
  grid-row: top-bar-start / top-bar-end;
  grid-column: app-start / app-end;
  background-color: var(--theme-accent-color);
  color: var(--theme-accent-text-color);
  display: flex;
  align-items: center;
  flex-direction: row;
}

#app-top-bar-main {
  flex: 1;
  display: flex;
  align-items: center;
  flex-direction: row;
  min-inline-size: 0;
  overflow: hidden;
}

#app-top-bar-side {
  inline-size: var(--drawer-width);
  display: flex;
  align-items: center;
  flex-direction: row;
  transition: inline-size 0.3s ease-in-out;
}

#app.app-drawer-closed #app-top-bar-side {
  inline-size: 4rem;
}

#app-top-bar-branding {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  box-sizing: border-box;
  min-inline-size: 0;
  flex: 1;
}

#app-top-bar-branding-logo {
  block-size: 1.5rem;
  inline-size: 6rem;
  background-color: var(--theme-accent-text-color);
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center / contain;
  opacity: 0.5;
  transition: ease-in-out 0.3s opacity;
  min-inline-size: 0;
}

#app.app-drawer-closed #app-top-bar-branding-logo {
  opacity: 0;
}

#app-top-bar-navigation {
  display: flex;
  flex: 1;
  flex-direction: row;
  block-size: 2.5rem;
  margin-block-start: .5rem;
  align-items: stretch;
}

.app-top-bar-navigation-start-edge, .app-top-bar-navigation-end-edge {
  fill: var(--theme-secondary-accent-color);
  flex-shrink: 0;
}

:dir(rtl) :is(.app-top-bar-navigation-start-edge, .app-top-bar-navigation-end-edge) {
  transform: scaleX(-1);
}

.app-top-bar-navigation-content {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: var(--theme-secondary-accent-color);
  color: var(--theme-accent-color);
}

#app-overlay {
  grid-row: app-start / app-end;
  grid-column: drawer-end / main-end;
  background-color: var(--theme-overlay-color);
  opacity: 1;
  transition: ease-in-out 0.3s opacity, ease-in-out 0.3s visibility;
}

#app.app-drawer-closed #app-overlay {
  visibility: hidden;
  opacity: 0;
  transition: ease-in-out 0.3s opacity, ease-in-out 0s 0.3s visibility;
}

#app-main {
  grid-row: main-start / main-end;
  grid-column: main-start / main-end;
  overflow: auto;
}

#app-drawer {
  grid-row: main-start / main-end;
  grid-column: drawer-start / drawer-end;
  background-color: var(--theme-accent-color);
  color: var(--theme-accent-text-color);
  overflow: hidden;
  opacity: 1;
  display: flex;
  flex-direction: row;
}

#app.app-drawer-closed #app-drawer {
  visibility: hidden;
  transition: ease-in-out 0s 0.3s visibility;
}

#app-drawer > #app-drawer-shortcuts {
  inline-size: 4rem;
  min-inline-size: 0;
  overflow-inline: hidden;
  overflow-block: auto;
}

#app-drawer > #app-drawer-navigation {
  background-color: var(--theme-secondary-accent-color);
  color: var(--theme-accent-color);
  flex: 1;
  min-inline-size: 0;
  overflow-inline: hidden;
  overflow-block: auto;
}

#app-drawer > #app-drawer-navigation:dir(ltr) {
  border-top-left-radius: 1rem;
}

#app-drawer > #app-drawer-navigation:dir(rtl) {
  border-top-right-radius: 1rem;
}

@media (min-width: 40rem) {
  #app-overlay {
    display: none !important;
  }

  #app.app-drawer-closed {
    grid-template-columns: [app-start drawer-start] 0 [drawer-end main-start] 1fr [main-end app-end];
  }

  #app.app-drawer-open {
    grid-template-columns: [app-start drawer-start] var(--drawer-width) [drawer-end main-start] 1fr [main-end app-end];
  }
}

.app-button {
  appearance: none;
  margin: 0;
  padding: 0;
  font-size: 1.5rem;
  background-color: transparent;
  color: inherit;
  border: none;
  inline-size: 3rem;
  block-size: 3rem;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.app-button:hover {
  opacity: .75;
}

.app-drawer-toggle-button {
  inline-size: 4rem;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":";AACA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,iCAAiC;EACjC,sCAAsC;EACtC,yCAAyC;EACzC,6BAA6B;EAC7B,uCAAuC;EACvC,kCAAkC;EAClC,gCAAgC;;EAEhC,qBAAqB;AACvB;;AAEA;EACE;UACQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,mJAAmJ;EACnJ,oDAAoD;EACpD,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,kGAAkG;EAClG,kDAAkD;AACpD;;AAEA;EACE,gGAAgG;AAClG;;AAEA;EACE,kHAAkH;AACpH;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;EAChC,2CAA2C;EAC3C,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gDAAgD;EAChD,wEAAkD;EAClD,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,OAAO;EACP,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,qDAAqD;EACrD,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,4CAA4C;EAC5C,UAAU;EACV,iEAAiE;AACnE;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oEAAoE;AACtE;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,sCAAsC;EACtC,2CAA2C;EAC3C,qCAAqC;EACrC,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,qDAAqD;EACrD,gCAAgC;EAChC,OAAO;EACP,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,gGAAgG;EAClG;;EAEA;IACE,kHAAkH;EACpH;AACF;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["\n:root, * {\n  --theme-primary-text-color: #333;\n  --theme-secondary-text-color: #666;\n  --theme-disabled-text-color: #999;\n  --theme-main-background-color: #f5f5f5;\n  --theme-primary-background-color: #ffffff;\n  --theme-accent-color: #3B9EA3;\n  --theme-secondary-accent-color: #d1e7e8;\n  --theme-accent-text-color: #ffffff;\n  --theme-overlay-color: #00000080;\n\n  --drawer-width: 20rem;\n}\n\n.material-symbols-outlined {\n  font-variation-settings:\n  'FILL' 1;\n}\n\n:root, body, #root, #app {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n  background-color: var(--theme-main-background-color);\n  color: var(--theme-primary-text-color);\n}\n\n#app {\n  display: grid;\n  grid-template-rows: [app-start top-bar-start] 3rem [top-bar-end main-start] 1fr [main-end app-end];\n  transition: ease-in-out 0.3s grid-template-columns;\n}\n\n#app.app-drawer-closed {\n  grid-template-columns: [app-start main-start drawer-start] 0 [drawer-end] 1fr [main-end app-end];\n}\n\n#app.app-drawer-open {\n  grid-template-columns: [app-start main-start drawer-start] var(--drawer-width) [drawer-end] 1fr [main-end app-end];\n}\n\n#app-top-bar {\n  grid-row: top-bar-start / top-bar-end;\n  grid-column: app-start / app-end;\n  background-color: var(--theme-accent-color);\n  color: var(--theme-accent-text-color);\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n}\n\n#app-top-bar-main {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  min-inline-size: 0;\n  overflow: hidden;\n}\n\n#app-top-bar-side {\n  inline-size: var(--drawer-width);\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  transition: inline-size 0.3s ease-in-out;\n}\n\n#app.app-drawer-closed #app-top-bar-side {\n  inline-size: 4rem;\n}\n\n#app-top-bar-branding {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: row;\n  box-sizing: border-box;\n  min-inline-size: 0;\n  flex: 1;\n}\n\n#app-top-bar-branding-logo {\n  block-size: 1.5rem;\n  inline-size: 6rem;\n  background-color: var(--theme-accent-text-color);\n  mask: url(logotype.svg) no-repeat center / contain;\n  opacity: 0.5;\n  transition: ease-in-out 0.3s opacity;\n  min-inline-size: 0;\n}\n\n#app.app-drawer-closed #app-top-bar-branding-logo {\n  opacity: 0;\n}\n\n#app-top-bar-navigation {\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  block-size: 2.5rem;\n  margin-block-start: .5rem;\n  align-items: stretch;\n}\n\n.app-top-bar-navigation-start-edge, .app-top-bar-navigation-end-edge {\n  fill: var(--theme-secondary-accent-color);\n  flex-shrink: 0;\n}\n\n:dir(rtl) :is(.app-top-bar-navigation-start-edge, .app-top-bar-navigation-end-edge) {\n  transform: scaleX(-1);\n}\n\n.app-top-bar-navigation-content {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--theme-secondary-accent-color);\n  color: var(--theme-accent-color);\n}\n\n#app-overlay {\n  grid-row: app-start / app-end;\n  grid-column: drawer-end / main-end;\n  background-color: var(--theme-overlay-color);\n  opacity: 1;\n  transition: ease-in-out 0.3s opacity, ease-in-out 0.3s visibility;\n}\n\n#app.app-drawer-closed #app-overlay {\n  visibility: hidden;\n  opacity: 0;\n  transition: ease-in-out 0.3s opacity, ease-in-out 0s 0.3s visibility;\n}\n\n#app-main {\n  grid-row: main-start / main-end;\n  grid-column: main-start / main-end;\n  overflow: auto;\n}\n\n#app-drawer {\n  grid-row: main-start / main-end;\n  grid-column: drawer-start / drawer-end;\n  background-color: var(--theme-accent-color);\n  color: var(--theme-accent-text-color);\n  overflow: hidden;\n  opacity: 1;\n  display: flex;\n  flex-direction: row;\n}\n\n#app.app-drawer-closed #app-drawer {\n  visibility: hidden;\n  transition: ease-in-out 0s 0.3s visibility;\n}\n\n#app-drawer > #app-drawer-shortcuts {\n  inline-size: 4rem;\n  min-inline-size: 0;\n  overflow-inline: hidden;\n  overflow-block: auto;\n}\n\n#app-drawer > #app-drawer-navigation {\n  background-color: var(--theme-secondary-accent-color);\n  color: var(--theme-accent-color);\n  flex: 1;\n  min-inline-size: 0;\n  overflow-inline: hidden;\n  overflow-block: auto;\n}\n\n#app-drawer > #app-drawer-navigation:dir(ltr) {\n  border-top-left-radius: 1rem;\n}\n\n#app-drawer > #app-drawer-navigation:dir(rtl) {\n  border-top-right-radius: 1rem;\n}\n\n@media (min-width: 40rem) {\n  #app-overlay {\n    display: none !important;\n  }\n\n  #app.app-drawer-closed {\n    grid-template-columns: [app-start drawer-start] 0 [drawer-end main-start] 1fr [main-end app-end];\n  }\n\n  #app.app-drawer-open {\n    grid-template-columns: [app-start drawer-start] var(--drawer-width) [drawer-end main-start] 1fr [main-end app-end];\n  }\n}\n\n.app-button {\n  appearance: none;\n  margin: 0;\n  padding: 0;\n  font-size: 1.5rem;\n  background-color: transparent;\n  color: inherit;\n  border: none;\n  inline-size: 3rem;\n  block-size: 3rem;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.app-button:hover {\n  opacity: .75;\n}\n\n.app-drawer-toggle-button {\n  inline-size: 4rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
